// extracted by mini-css-extract-plugin
export default {"container":"FlowStyles_container__Nk2tQ","desktop":"FlowStyles_desktop__NCKP0","viewport":"FlowStyles_viewport__bUIUy"};